import { render, staticRenderFns } from "./rewardThreeGiftEdit.vue?vue&type=template&id=6a42db45&scoped=true&"
import script from "./rewardThreeGiftEdit.vue?vue&type=script&lang=js&"
export * from "./rewardThreeGiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42db45",
  null
  
)

export default component.exports